module.exports = __webpack_public_path__ + "static/media/533JamesPBrawleyDrNW_2018-06-12_94.70056e89.jpg";